import { StipendExpenseStatus } from "@common/utils/graphql";
import { useMemo } from "react";
import {
  StipendExpense,
  useStipendExpensesByViewQuery,
} from "@common/utils/graphql";

const PAGE_SIZE = 20;
type StipendExpenseWithId = StipendExpense & { id: string };
export const useStipendsData = (
  currentPage: number,
  status: StipendExpenseStatus[],
  setPage: (idx: number) => void,
) => {
  const { loading, data: stipendsData } = useStipendExpensesByViewQuery({
    variables: {
      stipendExpenseStatus: status,
      offset: currentPage * PAGE_SIZE,
      pageSize: PAGE_SIZE + 1,
    },
    fetchPolicy: "cache-and-network",
  });

  const hasMorePages = useMemo(() => {
    if (
      stipendsData?.stipendExpensesByView.__typename !==
      "QueryStipendExpensesByViewSuccess"
    ) {
      return false;
    }
    return (
      stipendsData.stipendExpensesByView.data.stipendExpenses.length > PAGE_SIZE
    );
  }, [stipendsData]);

  const stipends = useMemo(() => {
    if (
      !stipendsData ||
      stipendsData.stipendExpensesByView.__typename !==
        "QueryStipendExpensesByViewSuccess"
    ) {
      return [];
    }
    const data = stipendsData.stipendExpensesByView.data.stipendExpenses
      .slice(0, PAGE_SIZE)
      .map((stipend) => ({ ...stipend, id: stipend.stipendExpenseId }));
    if (data.length === 0 && currentPage > 0) {
      setPage(currentPage - 1);
      return [];
    } else {
      return data as StipendExpenseWithId[];
    }
  }, [stipendsData, currentPage, setPage]);

  return {
    loading,
    hasMorePages,
    stipends,
  };
};
